import React from 'react';

function Spinner({ size = 'md', text = 'Loading...', overlay = false }) {
  const sizeClasses = {
    sm: 'spinner-border-sm',
    md: '',
    lg: 'spinner-border-lg'
  };

  const spinner = (
    <div className={`spinner-border ${sizeClasses[size]} text-primary`} role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  );

  if (overlay) {
    return (
      <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-light bg-opacity-75 z-50">
        <div className="text-center">
          {spinner}
          {text && <div className="text-muted mt-2">{text}</div>}
        </div>
      </div>
    );
  }

  return (
    <div className="text-center">
      {spinner}
      {text && <div className="text-muted mt-2">{text}</div>}
    </div>
  );
}

export default Spinner;